namespace $ { $mol_style_attach( "shm/hitalama/map/widget/entity/form/view/view.view.css",
 "[shm_hitalama_map_widget_entity_form_view_type_clear]:where(:not(:disabled)):hover {\n\tz-index: var(--mol_layer_focus);\n}\n[shm_hitalama_map_widget_entity_form_view_type_clear] {\n\tz-index: var(--mol_layer_focus);\n}\n"
) }